module.exports = __webpack_public_path__ + "static/media/chapa-y-pintura.8579be0b.png";